export default __webpack_public_path__ + "static/media/ic_remove_filter.867a8546.svg";